import get from 'lodash-es/get';
import has from 'lodash-es/has';
import isError from 'lodash-es/isError';

/**
 * Converts the input value into a string representation.
 * @param value - The value to be converted.
 * @returns The string representation of the input value.
 */

const tryStringify = (value: unknown) => {
  try {
    const stringified = JSON.stringify(value);

    return stringified;
  } catch (_) {
    try {
      return `${value}`;
    } catch (__) {
      if (has(value, 'message')) {
        return get(value, 'message') ?? typeof value;
      }

      return typeof value;
    }
  }
};

/**
 * Identifies a browser error without disrupting the app's operations.
 * @see https://docs.newrelic.com/docs/browser/new-relic-browser/browser-agent-spa-api/noticeerror-browser-agent-api
 *
 * @param error
 * @param extra
 */
const manageError = (error: unknown, extra?: Record<string, newrelic.SimpleType>) => {
  if (process.env.REACT_APP_NEW_RELIC === 'true' && typeof window.newrelic !== 'undefined') {
    const toLog = isError(error) ? error : new Error('Unknown error', { cause: error });
    const extraToLog = isError(error) ? extra : { ...extra, nrOriginalError: tryStringify(error) };
    newrelic.noticeError(toLog, extraToLog);
  } else {
    console.error('Manage error:', extra, error, typeof error);
  }
};

export default manageError;
